/* ---------------------------------------------------------------
	READY
 --------------------------------------------------------------- */
$(document).ready(function(){                     	
	
	if($("#fml_connexion").length > 0){
		fmlConnexion();
	}
	
	if($("#fml_mdp").length > 0){
		fmlMdp();
	}

	if($("#fml_reset_mdp").length > 0){
		fmlResetMdp();
	}

	if($("#fml_activation").length > 0){
		fmlActivation();
	}
	if($("#fml_activation_fast").length > 0){
		fmlActivationFast();
	}

	$(".upload_doc").click(function(){
		// Ligne impactée
		var fichierDoc = $(this).attr("data-doc");
		window.location = "/plugin/download/download.php?f=" + fichierDoc;					
	});

	$('[data-toggle="tooltip"]').tooltip()
	
	
	if (/MSIE (\d+\.\d+);/.test(navigator.userAgent)) { //test for MSIE x.x;
		 var ieversion=new Number(RegExp.$1) // capture x.x portion and store as a number
		 if (ieversion>=8)
		  document.write("You're using IE8 or above")
		 else if (ieversion>=7)
		  document.write("You're using IE7.x")
		 else if (ieversion>=6)
		  document.write("You're using IE6.x")
		 else if (ieversion>=5)
		  document.write("You're using IE5.x")
		  
		  
		$("#internet_explorer").show()
	}else{
		//$("#internet_explorer").show()
	}
	
	
	
	
	
});
/* ---------------------------------------------------------------
	CONNEXION
 --------------------------------------------------------------- */
function fmlConnexion(){
	$("#fml_connexion").validate({
		submitHandler: function(form) {
			var options = { 
				url: "/ELEARNING/ajax/connexion/check_login.php", 
				type: 'POST',	
				dataType: 'json',
		          beforeSend: function(){
					$("#alert_connexion").hide();
		          },
				success: function(json){					
					switch(json.clef_entree){
						case 0: 
							//$("#alert_connexion").html(json.message);
							$("#alert_connexion").fadeIn();
							break;
						case 1:	
							window.location = '/elearning/dashboard/';
							break;
					}
				}
			};
			$("#fml_connexion").ajaxSubmit(options);
			return false;
		}
	});	
}

/* ---------------------------------------------------------------
	RECUP MOT DE PASSE
 --------------------------------------------------------------- */
function fmlResetMdp(){
	$("#fml_reset_mdp").validate({
		submitHandler: function(form) {
			let options = { 
				url: "/ELEARNING/ajax/connexion/reset_password.php", 
				type: 'POST',	
				dataType: 'json',
				beforeSend: function(){
					$("#alert_reset_ko").hide();
                	},
	               success: function(retour){
		               if(retour == 'success'){
						window.location = '/elearning/dashboard/';
		               }else{
						$("#alert_reset_ko").html(retour.join("<br>"));
						$("#alert_reset_ko").show();
		               }
	               }
			};
			$("#fml_reset_mdp").ajaxSubmit(options);
			return false;
		}
	});
}

function fmlMdp(){	
	$("#fml_mdp").validate({
		submitHandler: function(form) {
			var options = { 
				url: "/ELEARNING/ajax/connexion/check_password.php", 
				type: 'POST',	
				dataType: 'json',
				beforeSend: function(){ 
					$(".alert").hide() 
					console.log("before")
				},
                success: function(retour){
					console.log("success")
					console.log(retour)
					switch(retour.statut){
						case 'error': // error
							$("#fml_mdp").hide();
							$("#alert_mdp_ko .message").html(retour.message);
							$("#alert_mdp_ko").show();
						break;
						case 'success': 
							$("#fml_mdp").hide();
							$("#alert_mdp_ok .message").html(retour.message);
							$("#alert_mdp_ok").fadeIn();
						break;
					}
               	}
			};
			$("#fml_mdp").ajaxSubmit(options);
			return false;
		}
	});
}

/* ---------------------------------------------------------------
	ACTIVATION
 --------------------------------------------------------------- */
function fmlActivation(){	
	$("#fml_activation").validate({
		submitHandler: function(form) {
			var options = { 
				url: "/ELEARNING/ajax/connexion/check_activation.php", 
				type: 'POST',	
				dataType: 'json',
				beforeSend: function(){
				 	$(".alert").hide()
				 	$("button[type=submit]").prop('disabled', true)
				 	$("button[type=submit]").html("Traitement en cours...")
				},
				success: function(json){					
				 	$("button[type=submit]").html("ACTIVER MON COMPTE")
				 	$("button[type=submit]").prop('disabled', false)
					switch(json.retour){
						case 0: // error
							$("#message_ko").html(json.message)
							$("#alert_ko").show()
							break;
						case 1: // ok
							window.location = '/elearning/dashboard/';
							break;
					}
				}
			}
			$("#fml_activation").ajaxSubmit(options)
			return false
		}
	});
	
}
function fmlActivationFast(){
	$("#fml_activation_fast").validate({
		submitHandler: function(form) {
			var options = { 
				url: "/ELEARNING/ajax/connexion/check_activation_fast.php", 
				type: 'POST',	
				dataType: 'json',
				beforeSend: function(){
				 	$("#alert_ko").hide()
				 	$("button[type=submit]").prop('disabled', true)
				 	$("button[type=submit]").html("Traitement en cours...")
				},
				success: function(retour){					
				 	$("button[type=submit]").html("ACTIVER MON COMPTE")
				 	$("button[type=submit]").prop('disabled', false)

		               if(retour.controle == 'ON'){
						window.location = '/elearning/dashboard/';
		               }else{
						$("#alert_ko").html(retour.message.join("<br>"));
						$("#alert_ko").show();
		               }
				}
			}
			$("#fml_activation_fast").ajaxSubmit(options)
			return false
		}
	});
}

// -------------------------------------------------------------
